module.exports = __webpack_public_path__ + "img/Feature.f74c0e0b.png";